import { z } from 'zod/v4';

import {
    animationPluginShapeLegacy,
    buttonHorizontalPositionSchema,
    buttonSizeSchema,
    extendedPositionPluginShapeLegacy,
    visibilityPluginShapeLegacy,
    widgetPositionPluginShapeLegacy,
} from '../../../common/schemas/legacy';

import { eduLoginButtonItemSchema } from './item';

/**
 * Data shape for the **default-placement** EDU-login button variant. Forked
 * verbatim from the button widget's `buttonLegacyDefaultDataSchema` so the two
 * widgets can diverge independently; the zero variant below derives from it via
 * `.extend()`.
 */
export const eduLoginButtonLegacyDefaultDataSchema = z.object({
    buttons: z.array(eduLoginButtonItemSchema),
    horizontalIndent: buttonSizeSchema,
    horizontalAlign: buttonHorizontalPositionSchema,
    mobileHorizontalAlign: buttonHorizontalPositionSchema.nullish(),
    tabletHorizontalAlign: buttonHorizontalPositionSchema.nullish(),
    isSynchronizeStyle: z.boolean().nullable(),
    ...visibilityPluginShapeLegacy,
    ...animationPluginShapeLegacy,
    ...widgetPositionPluginShapeLegacy,
});

/**
 * Data shape for the **zero-block-placement** EDU-login button variant — the
 * default schema with `position` overridden to the full extended-position grid
 * (per-device width/height/x/y/rotate/zIndex).
 */
export const eduLoginButtonLegacyZeroDataSchema = eduLoginButtonLegacyDefaultDataSchema.extend({
    ...extendedPositionPluginShapeLegacy,
});
